export default __webpack_public_path__ + "static/gradientBg-c4c1866ced92d8dc2b7062bab2d4e733.png";